import React from 'react';
import { Link } from 'react-router-dom';

import {
  ArrowRight,
  Bell,
  Envelope,
  FileText,
  FlowArrow,
  Sparkle
} from '@phosphor-icons/react';
/**
 * Workflows Coming Soon Page
 * Shown when ENABLE_WORKFLOWS feature flag is false
 */
const WorkflowsComingSoon = () => {
  const exampleWorkflows = [
    {
      icon: FileText,
      title: 'Assessment → Report → Email',
      description: 'When assessment completes, auto-generate a report and email it to stakeholders'
    },
    {
      icon: Sparkle,
      title: 'Org Chart → AI Analysis → Tasks',
      description: 'Upload org chart, run Opportunity Analyst, automatically create improvement tasks'
    },
    {
      icon: Bell,
      title: 'Booking → SMS → Reminder',
      description: 'When booking is created, send SMS confirmation and 24h reminder'
    }
  ];

  return (
    <div className="min-h-screen bg-[#161B26] text-white flex items-center justify-center p-6">
      <div className="max-w-2xl w-full">
        {/* Header */}
        <div className="text-center mb-10">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-2xl bg-gradient-to-br from-green-500/20 to-emerald-500/20 border border-green-500/30 mb-6">
            <FlowArrow className="text-green-400" size={40} />
          </div>
          <h1 className="text-3xl font-bold mb-3">Workflows Coming Soon</h1>
          <p className="text-[#A0AEC0] text-lg">
            Automate complex multi-step processes with our visual workflow builder.
          </p>
        </div>

        {/* Example Workflows */}
        <div className="bg-[#1A1B23] rounded-xl border border-[rgba(255,255,255,0.1)] p-6 mb-8">
          <h2 className="text-sm font-semibold text-[#A0AEC0] uppercase tracking-wider mb-4">
            Example Workflows You'll Be Able to Create
          </h2>
          <div className="space-y-4">
            {exampleWorkflows.map((workflow, index) => (
              <div 
                key={index}
                className="flex items-start gap-4 p-4 rounded-lg bg-[rgba(255,255,255,0.03)] border border-[rgba(255,255,255,0.05)]"
              >
                <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-green-500/10 flex items-center justify-center">
                  <workflow.icon className="text-green-400" size={20} />
                </div>
                <div>
                  <h3 className="font-medium text-white mb-1">{workflow.title}</h3>
                  <p className="text-sm text-[#718096]">{workflow.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="text-center space-y-4">
          <button
            disabled
            className="inline-flex items-center gap-2 px-6 py-3 bg-green-600/50 text-green-200 rounded-lg cursor-not-allowed"
            title="Coming soon"
          >
            <FlowArrow size={18} />
            Create FlowArrow
            <span className="ml-2 text-xs px-2 py-0.5 bg-green-500/20 rounded-full">Coming Soon</span>
          </button>
          
          <div>
            <Link 
              to="/dashboard"
              className="inline-flex items-center gap-2 text-[#6366F1] hover:text-[#818CF8] transition-colors"
            >
              <ArrowRight size={16} />
              Return to Dashboard
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorkflowsComingSoon;
